<script>
    import bulmaCollapsible from '@creativebulma/bulma-collapsible';

    export default {
        props: {
            types: Array,
            groups: Array,
            regions: Array,
            organizers: String,
            filterTypes: Array,
            filterGroups: Array,
            filterRegions: Array,
            filterOrganizers: Array,
            typesLabel: String,
            groupsLabel: String,
            regionsLabel: String,
            organizersLabel: String,
        },
        methods: {
            toggleType(typeName) {
                this.$emit('filter-type', typeName);
            },
            toggleGroup(groupName) {
                this.$emit('filter-group', groupName);
            },
            toggleRegion(regionName) {
                this.$emit('filter-region', regionName);
            },
            toggleOrganizer(organizerName) {
                this.$emit('filter-organizer', organizerName);
            },
        },
        updated() {
            if (!this.$refs.filter) return;
            this.$refs.filter.forEach($collapsible => {
                if (window.getComputedStyle($collapsible).height != '0px') bulmaCollapsible.attach($collapsible);
            });
        },
    };
</script>

<template>
    <div class="filtering">
        <div v-if="organizers.length" class="field">
            <h2 class="title is-5 has-text-text mb-3">{{ organizersLabel }}</h2>
            <div v-for="organizer in organizers" :key="organizer.Id" class="control mb-2">
                <input name="checkbox"
                       type="checkbox"
                       class="by-checkbox"
                       :id="'organizer-' + organizer.Id"
                       :value="organizer.Naam"
                       :checked="filterOrganizers.includes(organizer.Naam)"
                       @change="toggleOrganizer(organizer.Naam)" />
                <label :for="'organizer-' + organizer.Id" class="by-checkable">{{ organizer.Naam }}</label>
            </div>
        </div>

        <hr class="has-background-secondary" />

        <div v-if="types.length" class="field mb-5">
            <h2 class="title is-5 has-text-text mb-3">{{ typesLabel }}</h2>
            <div v-for="type in types" :key="type.Id" class="control mb-2">
                <input name="checkbox"
                       type="checkbox"
                       class="by-checkbox"
                       :id="'type-' + type.Id"
                       :value="type.Naam"
                       :checked="filterTypes.includes(type.Naam)"
                       @change="toggleType(type.Naam)" />
                <label :for="'type-' + type.Id" class="by-checkable">{{ type.Naam }}</label>
            </div>
        </div>

        <hr class="has-background-secondary" />

        <div v-if="groups.length" class="field mb-5">
            <h2 class="title is-5 has-text-text mb-3">{{ groupsLabel }}</h2>
            <template v-for="group in groups" :key="group.Id">
                <div class="control mb-2 is-flex is-align-items-center">
                    <input name="checkbox"
                           type="checkbox"
                           class="by-checkbox"
                           :id="'group-' + group.Id"
                           :value="group.Naam"
                           :checked="filterGroups.includes(group.Naam)"
                           @change="toggleGroup(group.Naam)" />
                    <label :for="'group-' + group.Id" class="by-checkable">{{ group.Naam }}</label>
                    <a v-if="group.Subdoelgroepen.length"
                       :href="`#collapse-${group.Id}`"
                       data-action="collapse"
                       class="collapse-trigger is-borderless is-hoverless ml-auto p-0">
                        <span class="icon is-rounded"><i class="fa-solid fa-plus"></i></span>
                    </a>
                </div>
                <div v-if="group.Subdoelgroepen.length"
                     class="is-collapsible"
                     :id="`collapse-${group.Id}`"
                     ref="filter">
                    <template v-for="subgroup in group.Subdoelgroepen" :key="subgroup.Id">
                        <div class="control mb-2 ml-4">
                            <input name="checkbox"
                                   type="checkbox"
                                   class="by-checkbox"
                                   :id="'subgroup-' + subgroup.Id"
                                   :value="subgroup.Naam"
                                   :checked="filterGroups.includes(subgroup.Naam)"
                                   @change="toggleGroup(subgroup.Naam)" />
                            <label :for="'subgroup-' + subgroup.Id" class="by-checkable">{{ subgroup.Naam }}</label>
                        </div>
                    </template>
                </div>
            </template>
        </div>

        <hr class="has-background-secondary" />

        <div v-if="regions.length" class="field">
            <h2 class="title is-5 has-text-text mb-3">{{ regionsLabel }}</h2>
            <div v-for="region in regions" :key="region.Id" class="control mb-2">
                <input name="checkbox"
                       type="checkbox"
                       class="by-checkbox"
                       :id="'region-' + region.Id"
                       :value="region.Naam"
                       :checked="filterRegions.includes(region.Naam)"
                       @change="toggleRegion(region.Naam)" />
                <label :for="'region-' + region.Id" class="by-checkable">{{ region.Naam }}</label>
            </div>
        </div>

    </div>
</template>
